const Do = () => {
    return (
        <div className="container m-auto">
            <div className="flex items-center justify-center h-screen">
                <h1 className="text-2xl font-bold text-zinc-700">انجام میدم</h1>
            </div>
        </div>
    )
}

export default Do